import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AgGridAngular } from 'ag-grid-angular';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { HighchartsChartComponent } from 'highcharts-angular';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzImageModule } from 'ng-zorro-antd/image';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzStepsModule } from 'ng-zorro-antd/steps';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { EnhancedKpiWidgetComponent } from '../components/enhanced-kpi-widget/enhanced-kpi-widget.component';
import { ForecastWidgetComponent } from '../components/forecast-widget/forecast-widget.component';
import { GaugeKpiWidgetComponent } from '../components/gauge-kpi-widget/gauge-kpi-widget.component';
import { GroupBreakdownKpiWidgetComponent } from '../components/group-breakdown-kpi-widget/group-breakdown-kpi-widget.component';
import { KpiWidgetComponent } from '../components/kpi-widget/kpi-widget.component';
import { PieChartKpiComponent } from '../components/pie-chart-kpi/pie-chart-kpi.component';
import { PositiveNumberOnlyDirective } from '../directives/positive-number-only.directive';
import { ResizedDirective } from '../directives/resized.directive';
import { GainsAgentCardComponent } from './gains-agent-card/gains-agent-card.component';
import { GainsAlertCardComponent } from './gains-alert-card/gains-alert-card.component';
import { GainsAlertsTrayComponent } from './gains-alerts-tray/gains-alerts-tray.component';
import { GainsDriverListComponent } from './gains-driver-list/gains-driver-list.component';
import { GainsEmbeddedDashboardComponent } from './gains-embedded-dashboard/gains-embedded-dashboard.component';
import { GainsFeedbackRowComponent } from './gains-feedback-row/gains-feedback-row.component';
import { GainsLayoutComponent } from './gains-layout/gains-layout.component';
import { GainsPieSvgComponent } from './gains-pie-svg/gains-pie-svg.component';
import { GainsRailItemBadgeComponent } from './gains-rail-item-badge/gains-rail-item-badge.component';
import { GainsToneTagCellComponent } from './gains-tone-tag-cell/gains-tone-tag-cell.component';
import { GainsCaptionCellComponent } from './gains-caption-cell/gains-caption-cell.component';
import { GainsSidenavComponent } from './gains-sidenav/gains-sidenav.component';
import { GainsSuggestedPathComponent } from './gains-suggested-path/gains-suggested-path.component';
import { GainsTrayComponent } from './gains-tray/gains-tray.component';
import { GainsSkuLocationsPanelComponent } from './gains-sku-locations-panel/gains-sku-locations-panel.component';
import { GainsTenantSwitcherComponent } from './gains-tenant-switcher/gains-tenant-switcher.component';
import { GaugeSvgComponent } from './gauge-svg/gauge-svg.component';
import { GainsUiCommonsModule } from '@gainsystems/gains-ui-commons';

@NgModule({
  declarations: [
    ResizedDirective,
    GainsLayoutComponent,
    GainsSidenavComponent,
    GainsSkuLocationsPanelComponent,
    ForecastWidgetComponent,
    KpiWidgetComponent,
    EnhancedKpiWidgetComponent,
    GroupBreakdownKpiWidgetComponent,
    PieChartKpiComponent,
    GainsPieSvgComponent,
    GaugeKpiWidgetComponent,
    GaugeSvgComponent,
    GainsTenantSwitcherComponent,
    GainsRailItemBadgeComponent,
    GainsTrayComponent,
    GainsAlertsTrayComponent,
    GainsAlertCardComponent,
    GainsDriverListComponent,
    GainsSuggestedPathComponent,
    GainsFeedbackRowComponent,
    GainsAgentCardComponent,
    GainsEmbeddedDashboardComponent,
    GainsToneTagCellComponent,
    GainsCaptionCellComponent
  ],
  imports: [
    CommonModule,
    NzMenuModule,
    GainsUiCommonsModule,
    AngularSvgIconModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    NzButtonModule,
    HighchartsChartComponent,
    NzLayoutModule,
    NzImageModule,
    PositiveNumberOnlyDirective
  ],
  exports: [
    GainsLayoutComponent,
    ResizedDirective,
    GainsSkuLocationsPanelComponent,
    PositiveNumberOnlyDirective,
    AngularSvgIconModule,
    ForecastWidgetComponent,
    KpiWidgetComponent,
    EnhancedKpiWidgetComponent,
    GroupBreakdownKpiWidgetComponent,
    PieChartKpiComponent,
    GaugeKpiWidgetComponent,
    GaugeSvgComponent,
    GainsTenantSwitcherComponent,
    GainsRailItemBadgeComponent,
    GainsTrayComponent,
    GainsAlertsTrayComponent,
    GainsAlertCardComponent,
    GainsDriverListComponent,
    GainsSuggestedPathComponent,
    GainsFeedbackRowComponent,
    GainsAgentCardComponent,
    GainsEmbeddedDashboardComponent,
    GainsToneTagCellComponent,
    GainsCaptionCellComponent,
    ReactiveFormsModule,
    GainsUiCommonsModule
  ]
})
export class GainsSharedModule {}
